import styled from 'styled-components';
import { media } from '../../../style/media';
import { contiOrange } from '../../../style/colors';

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  transition: all 0.2s;
  cursor: text;

  &:focus {
    outline: none;
    border-color: ${contiOrange};
    box-shadow: 0 0 0 3px rgba(255, 165, 0, 0.1);
  }
`;

export const PriceInputGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  ${media.s`
    grid-template-columns: 1fr;
  `}
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;

  ${media.s`
    flex-direction: column-reverse;
    
    button {
      width: 100%;
      justify-content: center;
    }
  `}
`;

